export default "__VITE_ASSET__DHPXpFUv__"